// 常用组件
import {
    Popup,
    Field,
    Form,
    Button,
    ConfigProvider,
    List
} from "vant";


export default {
    install(app) {
        app.use(Popup);
        app.use(Field);
        app.use(Form);
        app.use(Button);
        app.use(ConfigProvider);
        app.use(List);
    }
}